// extracted by mini-css-extract-plugin
export default {"ExtensionConfigurationHeader":"_ExtensionConfigurationHeader--Tiw40","ExtensionConfigurationBody":"_ExtensionConfigurationBody--Z1Dzh"};